import Banana from 'banana-i18n';
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import { ScrollToPlugin } from 'gsap/ScrollToPlugin';

gsap.registerPlugin(ScrollTrigger, ScrollToPlugin);

/*************
 * To finish the language translation set up, add the attribute data-lang-key to each piece of text in index.php on the parent directly
 * housing the text, since innerHTML will be used to replace the text. Make sure there is a language folder/file for the new
 * text in /src/i18n. The key (left-side) in the json file should match the value of the data-lang-key attribute in order
 * to match these up for text replacement. The same text can use the same data-lang-key value. For example, the desktop nav and the
 * mobile nav will have the same attribute values.
 *************/

const banana = new Banana('en', {});

const chooseLanguage = document.querySelectorAll('.uni__menu--language ul li a');
chooseLanguage.forEach((language) => {
  language.addEventListener('click', (e) => {
    if (language.dataset.locale === 'en') {
      const url = new URL(window.location.href);
      url.searchParams.set('lang', 'en');
      window.location.replace(url.toString());
    } else {
      changeLocale(language.dataset.locale);
    }
  }); 
});

function changeLocale(locale) {
  banana.setLocale(locale);

  // load the correct language json file
  fetch(`/src/i18n/${locale}.json?cacheBuster=2023-01-30_00`)
    .then((response) => response.json())
    .then((translations) => {
      banana.load(translations, locale);
      document.documentElement.lang = locale;

      // grab all strings with the specific data attribute
      const allStrings = document.querySelectorAll('[data-lang-key]');
      allStrings.forEach((indvString) => {

        // grab the data attribute value, which should match the "key" in the json files
        let keyValue = indvString.dataset.langKey;
        // confirm there's a key in the JSON file for that vale
        if (translations[keyValue]) {

          // match up text replacement by looking at the data attribute value and the key in the json file. Replace the text.
          indvString.innerHTML = translations[keyValue];
        } else {
          console.log('the data attribute value ' + keyValue + ' does not exist in the ' + locale + '.json file');
        }
      });


      // Calculate new lang URL, assign to history.
      const url = new URL(window.location.href);
      url.searchParams.set('lang', locale);
      window.history.pushState({}, '', url.toString());

      // Scroll back to top.
      window.scrollTo(0, 0);
      ScrollTrigger.refresh(true);
    });
  
}

// On load, check if different language should be used.
document.addEventListener('DOMContentLoaded', () => {
  const url = new URL(window.location.href);
  const activeLang = url.searchParams.get('lang');
  if (activeLang !== 'en') {
    changeLocale(activeLang);
  }
});
